<template>
  <div class="content-box">
    <div class="login-top">
      <div class="inline logo">
        <img src="../assets/logo.png" alt=""/>
      </div>
      <div class="inline go-back" @click="$router.push('/')">返回</div>
      <span class="inline fr">支付完成</span>
    </div>
    <div class="content-box-sco">
      <p>您已支付成功！</p>
      <p>金额：{{info && info.price ? info.price : ''}}元</p>
      <p>项目：{{info && info.service ? info.service      .name : ''}}</p>
      <!-- <p>有任何疑问请联系我们的客服</p>
      <p>客服电话：400-000-0000</p> -->
      <div class="tc" style="margin-top: 10%">
        <el-link icon="el-icon-notebook-2" type="primary" @click="$router.push({path: '/goods', query: {device: $route.query.device, hospital: $route.query.hospital}})">订单列表</el-link>
        <el-link icon="el-icon-edit" type="primary" @click="$router.push({path: '/modify', query: {device: $route.query.device, hospital: $route.query.hospital, orderId: $route.query.orderId}})">修改发票信息</el-link>
      </div>
    </div>
  </div>
</template>

<script>
import { getInfo } from '@/api'
export default {
  data () {
    return {
      info: {}
    }
  },
  mounted () {
    if (this.$route.query.orderId) {
      var formData = new FormData()
      formData.append('token', this.$cookies.get('h5_token'))
      getInfo(this.$route.query.orderId, formData).then(res => {
        this.info = res.data
        // this.form = {
        //   patient_mobile: res.data.patient_mobile,
        //   patient_name: res.data.patient_name,
        //   depart_name: res.data.depart_name,
        //   doctor_name: res.data.doctor_name,
        //   invoice_type: res.data.invoice_type,
        //   invoice_addr: res.data.invoice_addr,
        //   invoice_title: res.data.invoice_title
        // }
        // this.form.patient_mobile = res.data.patient_mobile
        // this.form.patient_name = res.data.patient_name
        // this.form.depart_name = res.data.invoice_title
        // this.form.doctor_name = res.data.doctor_name
        // this.form.invoice_addr = res.data.invoice_addr
        // this.form.invoice_title = res.data.invoice_title
        // this.form.hospital_name = res.data.hospital_name
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.content-box-sco{
  padding: 0 5%;
  p{
    line-height: 40px;
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/payAccomplish.vue